export default __webpack_public_path__ + "static/media/10.8737ff8d.jpg";